/* euroguard · Página «Contacto»
   - Motivo: las píldoras cambian la pista, el texto de ejemplo del mensaje, muestran u ocultan «Número de pedido»
     y rellenan el campo oculto contact[Motivo] que llega en el correo.
   - Enlaces con ?motif=clave o data-eg-set-reason="clave" (franja de profesionales) preseleccionan el motivo.
   - Tras enviar, lleva el foco al mensaje de éxito o de error. */
(function () {
  'use strict';
  if (window.__egContact) return;
  window.__egContact = true;

  function $(sel, root) { return (root || document).querySelector(sel); }
  function $$(sel, root) { return Array.prototype.slice.call((root || document).querySelectorAll(sel)); }

  function initForm(root) {
    if (root.dataset.egReady) return;
    root.dataset.egReady = '1';
    var radios = $$('[data-eg-reason]', root), hint = $('[data-eg-hint]', root), hidden = $('[data-eg-reason-field]', root);
    var orderField = $('[data-eg-order-field]', root), message = $('[data-eg-message]', root);

    function apply(radio, opts) {
      opts = opts || {};
      if (!radio) return;
      radio.checked = true;
      if (hint) hint.textContent = radio.getAttribute('data-hint') || '';
      if (hidden) hidden.value = radio.getAttribute('data-label') || radio.value;
      if (message) message.placeholder = radio.getAttribute('data-placeholder') || '';
      if (orderField) orderField.hidden = radio.getAttribute('data-order') !== 'true';
      if (opts.scroll) {
        root.scrollIntoView({ behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth', block: 'start' });
        if (opts.focus && message) setTimeout(function () { message.focus({ preventScroll: true }); }, 450);
      }
    }
    function select(key, opts) {
      if (!key) return false;
      key = String(key).toLowerCase();
      var radio = radios.filter(function (r) { return r.value === key; })[0];
      if (!radio) return false;
      apply(radio, opts);
      return true;
    }

    radios.forEach(function (r) { r.addEventListener('change', function () { apply(r); }); });
    var checked = radios.filter(function (r) { return r.checked; })[0];
    apply(checked || radios[0]);

    /* ?motif=… en la URL o data-eg-set-reason en cualquier enlace de la página */
    var m = /[?&]motif=([^&#]+)/.exec(location.search);
    if (m) select(decodeURIComponent(m[1]), { scroll: true });
    document.addEventListener('click', function (e) {
      var a = e.target.closest('[data-eg-set-reason]');
      if (!a) return;
      var href = a.getAttribute('href') || '';
      if (href && href.charAt(0) !== '#') return; // enlace externo: se respeta
      if (select(a.getAttribute('data-eg-set-reason'), { scroll: true, focus: true })) e.preventDefault();
    });

    /* Estado tras enviar */
    var status = $('[data-eg-status]', root);
    if (status) {
      setTimeout(function () {
        status.scrollIntoView({ behavior: 'auto', block: 'center' });
        status.focus({ preventScroll: true });
      }, 100);
    }
  }

  function boot() { $$('[data-eg-cform]').forEach(initForm); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('shopify:section:load', function (e) {
    $$('[data-eg-cform]', e.target).forEach(function (r) { delete r.dataset.egReady; initForm(r); });
  });
  document.addEventListener('shopify:block:select', function (e) {
    var label = e.target && e.target.closest && e.target.closest('.eg-reason');
    var radio = label && label.querySelector('[data-eg-reason]');
    if (radio) { radio.checked = true; radio.dispatchEvent(new Event('change', { bubbles: true })); }
  });
})();
